<template>
  <v-select
    v-model="selected"
    :items="campaignQuarterOptions"
    item-text="name"
    item-value="value"
    label="Campaign Qtr"
    :readonly="readonly"
    @input="val => $emit('updatedCampaignQuarter', val)"
    hide-details="auto"
    dense
  ></v-select>
</template>

<script>
  import { getCampaignQuarters } from '@/common/U_D'

  export default {
    props: {
      initialValue: {
        type: String,
        default: null,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      selected: {
        get() {
          return this.initialValue || ''
        },
        set(newVal) {
          // No action needed
        },
      },
      campaignQuarterOptions() {
        return getCampaignQuarters()
      },
    },
  }
</script>



// WEBPACK FOOTER //
// CampaignQuarterSelect.vue?2c751875